import Api from '../../Base'

class GetShelfProductsWithPOS extends Api {
  requestUrl = `/api/shelf/${this.getParams().id}/pos`
}

export default GetShelfProductsWithPOS
